import { Container } from '@mui/material';
import { AccountListNew } from '../sections/AccountListNew';
import Metatags from '../components/MetaTags/MetaTags';

export default function AccountsWithLicenseListPage({ permissions }) {
  return (
    <>
      <Metatags metaTagName="Accounts | ISV Insights" />
      <Container maxWidth="xl">
        <AccountListNew permissions={permissions} />
      </Container>
    </>
  );
}
